import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const Component = () => {
  const navigate = Route.useNavigate();
  // Work around a bizarre router bug where the navigation uses the previous params instead of the current ones
  useEffect(() => {
    const t = setTimeout(
      () => navigate({ to: "./details", from: Route.fullPath, replace: true }),
      0,
    );
    return () => clearTimeout(t);
  }, [navigate]);
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/profile/")({
  component: Component,
});
